import React, { useState } from "react";
import MobileCollegeCard from "./mobileCollegeCard";

const MobileResults = ({ filteredColleges, rankKey, formData, classifyRisk }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const collegesPerPage = 10; // Number of colleges per page

  // Sort colleges by rankKey ascending before paginating - Handle non-numeric ranks
  const sortedColleges = [...filteredColleges].sort((a, b) => {
    const rankA = a[rankKey];
    const rankB = b[rankKey];

    // Check if ranks are non-numeric (like "-" or "NA")
    const isARankless = !/^\d+$/.test(rankA);
    const isBRankless = !/^\d+$/.test(rankB);

    if (isARankless && isBRankless) return 0; // Both are rankless, keep order
    if (isARankless) return 1; // A is rankless, move it to the end
    if (isBRankless) return -1; // B is rankless, move it to the end

    // Both have numeric ranks, sort them numerically
    return parseInt(rankA, 10) - parseInt(rankB, 10);
  });

  // Calculate the indices for slicing the data
  const indexOfLastCollege = currentPage * collegesPerPage;
  const indexOfFirstCollege = indexOfLastCollege - collegesPerPage;
  const currentColleges = sortedColleges.slice(
    indexOfFirstCollege,
    indexOfLastCollege
  );

  // Calculate total pages
  const totalPages = Math.ceil(filteredColleges.length / collegesPerPage);

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div className="md:hidden">
      <div className="max-h-[500px] overflow-y-auto">
        {currentColleges.map((college, index) => {
          const collegeRank = parseInt(college[rankKey]) || 0;
          const studentRank = parseInt(formData.rank) || 0;
          const riskClass = classifyRisk(studentRank, collegeRank);

          const cardBorderClass =
            riskClass === "safety-safe"
              ? "border-green-300"
              : riskClass === "safety-moderate"
              ? "border-yellow-300"
              : "border-red-300";

          const statusText =
            riskClass === "safety-safe"
              ? "Safe Choice"
              : riskClass === "safety-moderate"
              ? "Moderate Chance"
              : "Ambitious Choice";

          const statusClass =
            riskClass === "safety-safe"
              ? "bg-green-50 text-green-700 ring-1 ring-green-600/20"
              : riskClass === "safety-moderate"
              ? "bg-yellow-50 text-yellow-700 ring-1 ring-yellow-600/20"
              : "bg-red-50 text-red-700 ring-1 ring-red-600/20";

          return (
            <MobileCollegeCard
              key={index}
              college={college}
              rankKey={rankKey}
              studentRank={studentRank}
              statusClass={statusClass}
              statusText={statusText}
              cardBorderClass={cardBorderClass}
            />
          );
        })}
      </div>

      {/* Pagination Controls */}
      <div className="flex justify-between items-center mt-4">
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className={`px-4 py-2 rounded-lg border ${
            currentPage === 1
              ? "bg-gray-200 text-gray-400 cursor-not-allowed"
              : "bg-white text-gray-700 hover:bg-gray-100 border-gray-300"
          }`}
        >
          Previous
        </button>

        <p className="text-sm text-gray-600">
          Page <span className="font-medium">{currentPage}</span> of{" "}
          <span className="font-medium">{totalPages}</span>
        </p>

        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className={`px-4 py-2 rounded-lg border ${
            currentPage === totalPages
              ? "bg-gray-200 text-gray-400 cursor-not-allowed"
              : "bg-white text-gray-700 hover:bg-gray-100 border-gray-300"
          }`}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default MobileResults;
